<div [formGroup]="addPartnerForm">
    <div class="add-partner-header bil-space-between">
        <span class="bil-font-extra-large bil-font-weight">Add Partner</span>
        <span></span>
        <span class="bil-right-padding-20"><img (click)="closeModal()" class="bil-pointer-class"
                src="../../../../assets/images/smallclose.svg" /></span></div>
    <!-- <div class="bil-align-item-end bil-right-padding-10 bil-top-padding-10"> <img
            src="../../../../assets/images/smallclose.svg" /></div> -->
    <div class="input-names">
        <mat-form-field appearance="outline" floatLabel="never" class="">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="firstName" placeholder="First Name" autocomplete="off">
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="never" class="">
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="lastName" placeholder="Last Name" autocomplete="off">
        </mat-form-field>
        <div class="display-in-center">
            <button id="bil-add-partner-submit" type="button" class="bil-font-regular button-style" mat-raised-button
                color="primary" [disabled]="(!(addPartnerForm.valid))" (click)="addPartner()">
                Add
            </button>
        </div>
    </div>
</div>